import { Injectable } from '@angular/core';

import { HrefLangDefinition } from './hreflang.service';
import { AppSettings } from '../settings/app.settings';

@Injectable()
export class CheckingUrl{
    compareUrl(hreflangs:HrefLangDefinition[], currentUrl:string):any{
        let result = null;
        let splittedUrl = currentUrl.split("/");
        let _hreflang = hreflangs[0];
        if(hreflangs.length > 1){
            _hreflang = hreflangs.find(hreflang=>{
                return splittedUrl[1] == hreflang.hreflang;
            });
            if(!_hreflang){
                _hreflang = hreflangs[0];
            }
        }

        if(splittedUrl.length == 4 || splittedUrl.length == 3){
            if(_hreflang.href != `${AppSettings.BASE_DOMAIN}${currentUrl}`)
                result = {url:_hreflang.href, status: 301};

        }else if(splittedUrl.length == 6){
            if(_hreflang.href != `${AppSettings.BASE_DOMAIN}${currentUrl}`){
                let correctPath = _hreflang.href.replace(AppSettings.BASE_DOMAIN, "");
                if(correctPath.split("/")[2] == splittedUrl[2])
                    result = {url:_hreflang.href, status: 301};
                else
                    result = {url:_hreflang.href, status: 404};
            }
        }
        return result;
    }
}